module.exports = __webpack_public_path__ + "a8a10a3e/img/verified-icon.f93bbc14.svg";